<template>

  <EntityManager
      heading="Изписвания"
      heading-create="Ново изписване"
      heading-modify="Редактиране на изписване"
      heading-delete="Изтриване на изписване"
      message-delete="Избраният документ за изписване ще бъде изтрит. Сигурни ли сте?"
      resource="/consumption"
      >
    <template #table>
      <Column field="number" header="Номер" style="flex: 0 0 10em" bodyClass="right"></Column>
      <Column field="date" header="Дата" style="flex: 0 0 8em" bodyClass="right">
        <template #body="props">
          {{new Date(props.data.date).toLocaleDateString()}}
        </template>
      </Column>
      <Column field="store.name" header="Склад" footerClass="right">
        <template #footer>
          Общо:
        </template>
      </Column>
      <Column field="netto" header="Стойност" style="flex: 0 0 10em" bodyClass="right" headerClass="right" footerClass="right">
        <template #body="props">
          {{$utils.currency(props.data.netto)}}
        </template>
        <template #footer>
          {{$utils.currency(0)}}
        </template>
      </Column>
      <Column field="vat" header="ДДС" style="flex: 0 0 10em" bodyClass="right" headerClass="right" footerClass="right">
        <template #body="props">
          {{$utils.currency(props.data.vat)}}
        </template>
        <template #footer>
          {{$utils.currency(0)}}
        </template>
      </Column>
      <Column field="total" header="Общо" style="flex: 0 0 10em" bodyClass="right" headerClass="right" footerClass="right">
        <template #body="props">
          {{$utils.currency(props.data.total)}}
        </template>
        <template #footer>
          {{$utils.currency(0)}}
        </template>
      </Column>
    </template>
    <template v-slot:form="props">
      <Consumption v-model="props.entity"/>
    </template>
  </EntityManager>
</template>

<script>

export default {
  data() {
    return {
      contragents : [],
      stores : [],
      tbl: {
        selected: null,
        edit: false,
      }
    }
  },

  created() {
    //this.items = new ProductDeliveryService().getAll().data;
  },

  methods: {
    onRead(event) {
      this.tbl.selected = null;
      event.onSuccess(event.item);
      this.item = event.item;
    },
    changeDocument(document) {
      this.$emit('update:modelValue', document)
    },
    // onItemLoad(data) {
    //   for(var k in this.tbl.selected) {
    //     data[k] = this.tbl.selected[k];
    //   }
    // },
    // onItemSave(data) {
    //   for(var k in data) {
    //     this.tbl.selected[k] = data[k];
    //   }
    // },
    // onSelect(data) {
    //   console.log(data, "Избиране на доставка");
    // },
    // onItemSelect(data) {
    //   this.tbl.selected = data.data;
    //   this.tbl.edited = {};
    //   console.log(this.tbl.selected, "Избиране на елемент от доставка");
    // },
    // onItemEditChange() {
    //   if (this.tbl.edited) {
    //     // var e = this.tbl.edited;
    //     // e.net = e.quantity * e.price;
    //     // var p = e.vatP / 100;
    //     // e.gros = e.net * (1 + p);
    //     // e.vat = e.gros - e.net;
    //   }
    // },
    // onItemEdit() {
    //   if (this.tbl.selected) {
    //     this.tbl.edited = {
    //       id : this.tbl.selected.id,
    //       pos : this.tbl.selected.pos,
    //       product : this.tbl.selected.product,
    //       quantity : this.tbl.selected.quantity,
    //       price : this.tbl.selected.price,
    //       vatP : this.tbl.selected.vatP
    //     }
    //   } else {
    //     this.tbl.edited = {
    //       pos : this.tbl.items.length + 1,
    //       product : {},
    //       vatP : 20
    //     }
    //   }
    //   this.tbl.edited.net = function() { return this.tbl.edited.quantity * this.tbl.edited.price };
    //   this.onItemEditChange();
    //   this.tbl.edit = true;
    // },
    onDelete(event) {
      event.onFailure("Елементът се използва.");
      console.log(event, "Избиране на контрагент");
    },
    onSave(event) {
      event.onSuccess();
      //event.onFailure("Елементът се използва.");
    },
    total(f) {
      var total = 0;
      for(const item of this.item.items) {
        total += f(item);
      }
      return total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    currency(f) {
      return f.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    count() {
      return this.item.items.length;
    }
  }
}
</script>
